__turbopack_context__.v({
  "expanded": "sticky-nav-module-scss-module__fgzM2q__expanded",
  "flyout": "sticky-nav-module-scss-module__fgzM2q__flyout",
  "flyout-link-icon": "sticky-nav-module-scss-module__fgzM2q__flyout-link-icon",
  "flyout-link-text": "sticky-nav-module-scss-module__fgzM2q__flyout-link-text",
  "nav": "sticky-nav-module-scss-module__fgzM2q__nav",
  "overlay": "sticky-nav-module-scss-module__fgzM2q__overlay",
  "placeholder": "sticky-nav-module-scss-module__fgzM2q__placeholder",
  "toggle": "sticky-nav-module-scss-module__fgzM2q__toggle",
  "visible": "sticky-nav-module-scss-module__fgzM2q__visible",
});
